import { Link } from 'react-router-dom';
import Reveal from '@/components/base/Reveal';
import SectionHeading from '@/components/base/SectionHeading';
import { sectionsOverview } from '@/mocks/strategix';

export default function SectionsOverview() {
  return (
    <section className="relative w-full px-5 md:px-10 py-20 md:py-28">
      <div className="max-w-6xl mx-auto">
        <SectionHeading
          label="Что внутри"
          title="Познакомьтесь с агентством за несколько кликов"
          description="Каждый раздел — отдельная страница. Открывайте в новой вкладке и изучайте детали: кто мы, что гарантируем, сколько стоят услуги и как с нами связаться."
        />

        <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {sectionsOverview.map((section, index) => (
            <Reveal key={section.path} delay={index * 80} className="h-full">
              <Link
                to={section.path}
                target="_blank"
                rel="noopener noreferrer"
                className="group h-full flex flex-col p-6 rounded-lg bg-background-100/70 border border-background-200/70 hover:border-primary-400/60 transition-colors cursor-pointer"
              >
                <div className="flex items-center justify-between">
                  <span className="w-12 h-12 flex items-center justify-center rounded-md bg-primary-500/15 text-primary-300 group-hover:bg-primary-500/25 transition-colors">
                    <i className={`${section.icon} text-2xl`}></i>
                  </span>
                  <i className="ri-arrow-right-up-line text-xl text-foreground-500 group-hover:text-primary-300 transition-colors"></i>
                </div>
                <h3 className="mt-5 font-heading text-base md:text-lg text-foreground-950">{section.title}</h3>
                <p className="mt-3 text-sm text-foreground-600 leading-relaxed flex-1">{section.text}</p>
                <span className="mt-5 inline-flex items-center gap-2 text-sm font-semibold text-primary-300">
                  Открыть раздел
                  <i className="ri-arrow-right-line text-base"></i>
                </span>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}